import React from 'react';

export const Glyph = (
  <svg viewBox="0 0 32 32" className="chart-glyph series-radar-chart-glyph">
    <g className="radar-glyph-grid">
      <polygon
        className="radar-glyph-grid-ring"
        points="16,10.258333333333333 20.97242919339565,13.129166666666666 20.97242919339565,18.870833333333334 16,21.741666666666667 11.027570806604349,18.870833333333337 11.027570806604345,13.12916666666667"
      ></polygon>
      <polygon
        className="radar-glyph-grid-ring"
        points="16,6.574999999999999 24.162289430668334,11.2875 24.162289430668338,20.7125 16,25.425 7.8377105693316675,20.712500000000006 7.837710569331662,11.287500000000005"
      ></polygon>
      <line
        className="radar-glyph-grid-axis"
        x1="16"
        y1="16"
        x2="16"
        y2="3"
      ></line>
      <line
        className="radar-glyph-grid-axis"
        x1="16"
        y1="16"
        x2="27.2583302491977"
        y2="9.5"
      ></line>
      <line
        className="radar-glyph-grid-axis"
        x1="16"
        y1="16"
        x2="27.258330249197705"
        y2="22.5"
      ></line>
      <line
        className="radar-glyph-grid-axis"
        x1="16"
        y1="16"
        x2="16"
        y2="29"
      ></line>
      <line
        className="radar-glyph-grid-axis"
        x1="16"
        y1="16"
        x2="4.7416697508023"
        y2="22.500000000000004"
      ></line>
      <line
        className="radar-glyph-grid-axis"
        x1="16"
        y1="16"
        x2="4.741669750802293"
        y2="9.500000000000007"
      ></line>
    </g>
    <polygon
      className="radar-glyph-series"
      points="16,7.5 24.2,12.2 23.4,21 16,24.8 8.8,20.4 14,15.8"
    ></polygon>
    <g className="radar-glyph-boundary">
      <polyline
        className="radar-boundary-segment stroke-only palette-cat-1"
        points="10.371,6.25 16,3 21.629,6.25"
      ></polyline>
      <polyline
        className="radar-boundary-segment stroke-only palette-cat-1"
        points="21.629,6.25 27.258,9.5 27.258,16"
      ></polyline>
      <polyline
        className="radar-boundary-segment stroke-only palette-cat-1"
        points="27.258,16 27.258,22.5 21.629,25.75"
      ></polyline>
      <polyline
        className="radar-boundary-segment stroke-only palette-cat-2"
        points="21.629,25.75 16,29 10.371,25.75"
      ></polyline>
      <polyline
        className="radar-boundary-segment stroke-only palette-cat-3"
        points="10.371,25.75 4.742,22.5 4.742,16"
      ></polyline>
      <polyline
        className="radar-boundary-segment stroke-only palette-cat-3"
        points="4.742,16 4.742,9.5 10.371,6.25"
      ></polyline>
    </g>
  </svg>
);

export default Glyph;
